import { render, staticRenderFns } from "./RegionInformation.vue?vue&type=template&id=0c975707"
import script from "./RegionInformation.vue?vue&type=script&lang=js"
export * from "./RegionInformation.vue?vue&type=script&lang=js"
import style0 from "./RegionInformation.vue?vue&type=style&index=0&id=0c975707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports